<template>
<div class="trail" :class="{'trail__hide': !displayNav}">
    <div class="trail__nav" :class="{'trail__nav--hide': !displayNav}">
        <button v-for="item in menu" :key="item.svg" @click="moveTo(item.target)" :aria-label="item.name">
            <Svg :icon="item.svg" className="trail__nav--svg" />
        </button>
    </div>
</div>

  
</template>

<script>
import { ref, watch } from 'vue'
import Svg from '../utils/Svg.vue';

import scrollTo from '../../composables/scroll';

export default {
    components:{
        Svg
    },
    props:['display'],
    setup(props){
        const displayNav = ref(props.display);

        watch(() => props.display, () =>{
            displayNav.value = props.display;
        })

        const menu = [
            {
                svg:"infos",
                target:"trail-data",
                name:"trail data"
            },
            {
                svg:"map",
                target:"trail-map",
                name:"trail map"              
            },
            {
                svg:"link",
                target:"trail-link",
                name:"trail map"              
            },
            {
                svg:"survey",
                target:"trail-survey",
                name:"trail map"              
            },
            {
                svg:"camera",
                target:"trail-pictures",
                name:"trail pictures"              
            },
            {
                svg:"messenger",
                target:"trail-comment",
                name:"trail comments"              
            },
            {
                svg:"trail",
                target:"trail-nearby",
                name:"trail nearby"              
            }
        ];

        const moveTo = (target) => {
            console.log(target);
            scrollTo(target);
        }


        return {displayNav, menu, moveTo}
    }
}
</script>

<style lang="scss" scoped>

@import '../../style/main';

$side-nav : 8rem;

.trail{
    width: $side-nav;
    position: relative;
    transition: all .2s;

    &__hide{
        width: 0rem !important;
    }
    

    &__nav{
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        width: $side-nav;
        background-color: $color-blue-light;
        z-index: 100;
        color:$color-white;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        transition: all .2s;

        &--hide{
            transform: translateX(-8rem);
        }

        & button{
            @include buttonNoStyle;
            display: flex;
            align-items: center;
            justify-content: center;
            &:not(:last-child){
                margin-bottom: 2rem;
            }
            transition: all .2s;

            &:hover{
                transform: scale(1.1);
            }
        }

        &--svg{
            @include svg(3.4rem);
        }

    }
}

</style>